module.exports = new __parcel__URL__("immersive_earth.34fa8a8c.png").toString();